import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchJobDocuments } from "src/redux/reducers/JobDocument";
import queryString from "query-string";
import ExportForm from "../Form/ExportForm";
import { useLocation, useHistory } from "react-router-dom";
import { Col, Row, Button, Spinner } from "react-bootstrap";
import DocumentSelector from "../DataArchive/TransactionManager/DocumentSelector";
import DownloadAutomaticMode from "../DataArchive/TransactionManager/DownloadOptions/DownloadAutomaticMode";
import AutomaticModeTable from "../DataArchive/TransactionManager/AutomaticModeTable";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { ReduxState } from "../../../redux";
import { useRecentDocument } from "src/hooks/useRecentNavigation";

export const AutomaticDocs = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const history = useHistory();
  const [hasData, setHasData] = useState<boolean | null>(null); // null = loading, true = has data, false = empty

  const { data: jobDocs, loading } = useSelector(
    (state: ReduxState) => state.JobDocument
  );

  const { selectedL1, selectedL2 } = useSelector(
    (state: ReduxState) => state.TagLevel
  );

  // Track this page view as a recent document
  useRecentDocument(
    selectedL1 && selectedL2
      ? {
          docType: "other-docs",
          label: `Other Documents - ${selectedL2}`,
          icon: "file",
          l1: selectedL1,
          l2: selectedL2,
        }
      : null
  );

  // React.useEffect(() => {
  //   const { l1, l2 } = queryString.parse(location.search);
  //   // console.log("1");
  //   dispatch(
  //     fetchJobDocuments({
  //       fieldName: "generic",
  //     })
  //   );
  // }, [location.search, dispatch]);

  useEffect(() => {
    // Set hasData based on jobDocs
    if (jobDocs && Array.isArray(jobDocs)) {
      setHasData(jobDocs.length > 0);
    } else {
      setHasData(false);
    }
  }, [jobDocs]);

  // Empty State Component
  const EmptyStateComponent = () => (
    <div
      className="d-flex flex-column align-items-center justify-content-center"
      style={{ minHeight: "400px" }}
    >
      <div className="text-center mb-4">
        <FontAwesomeIcon icon="file" size="4x" className="text-muted mb-3" />
        <h4 className="text-muted">No Documents Found</h4>
        <p className="text-muted">Get started by adding your documents</p>
      </div>

      <div>
        <Button
          variant="primary"
          size="lg"
          onClick={() => {
            const currentParams = new URLSearchParams(window.location.search);
            history.push(
              `/extract/customDocument/${
                currentParams.toString() ? "?" + currentParams.toString() : ""
              }`
            );
          }}
          className="d-flex flex-column align-items-center p-4"
          style={{ minWidth: "250px" }}
        >
          <FontAwesomeIcon icon="file" size="2x" className="mb-2" />
          <strong>Add Documents</strong>
        </Button>
      </div>
    </div>
  );

  // Show a spinner while the JobDocument fetch is in flight so the user
  // never sees a blank panel before the table or empty state resolves.
  if (loading && (!jobDocs || jobDocs.length === 0)) {
    return (
      <div
        className="p-4 d-flex flex-column align-items-center justify-content-center"
        style={{ minHeight: "400px" }}
      >
        <Spinner animation="border" role="status" />
        <small className="text-muted mt-2">Loading documents…</small>
      </div>
    );
  }

  // Show empty state if no documents found
  if (
    hasData === false &&
    jobDocs &&
    Array.isArray(jobDocs) &&
    jobDocs.length === 0 &&
    !loading
  ) {
    return (
      <div className="p-4">
        <Row>
          <Col md="12">
            <EmptyStateComponent />
          </Col>
        </Row>
      </div>
    );
  }

  return (
    <>
      <Row className="justify-content-end align-items-center">
        <Col>
          <DocumentSelector />
        </Col>
        <Col className="justify-content-end">
          <DownloadAutomaticMode />
        </Col>
      </Row>
      <div className="mt-4">
        <AutomaticModeTable />
      </div>
    </>
  );
};
